/** @file Viewport panel body: toolbar, the WebGL canvas (focusable, drawn outside React), the notice line. */
import type { IDockviewPanelProps } from 'dockview-react';
import { useEffect, useRef } from 'react';
import { useT } from '../../shell/i18n/useT';
import { mountViewport } from './mountViewport';
import { ViewportNoticeLine } from './ViewportNoticeLine';
import { ViewportToolbar } from './ViewportToolbar';
import './viewport.css';

/** The canvas needs tabIndex 0 so focus (and the viewport key context) can land on it; offers reach the dock. */
export function ViewportPanel({ api, containerApi }: IDockviewPanelProps) {
  const t = useT();
  const ref = useRef<HTMLCanvasElement | null>(null);
  useEffect(() => (ref.current === null ? undefined : mountViewport(ref.current)), []);
  return (
    <div className="viewport-panel" data-testid={`panel-${api.id}`}>
      <ViewportToolbar t={t} />
      <canvas ref={ref} className="viewport-canvas" tabIndex={0} aria-label={t('viewport.canvas')} />
      <ViewportNoticeLine t={t} dock={containerApi} />
    </div>
  );
}
